module.exports = __webpack_public_path__ + "img/4.0ec65d8c.png";